import { render, staticRenderFns } from "./ReportBuilderEmbed.vue?vue&type=template&id=a84f8b72&scoped=true&"
import script from "./ReportBuilderEmbed.vue?vue&type=script&lang=js&"
export * from "./ReportBuilderEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84f8b72",
  null
  
)

export default component.exports